/*
 * Pressidium vs Kinsta Comparison Page JavaScript
 * Entry point for the comparison landing page.
 * Uses Edge build system (Vite + Tailwind 4).
 */

import './comparison.css';

// Shared utilities (nav, topbar, coupon bar, mobile + mega menu)
import '../shared/topbar.js';
import '../shared/coupon.js';
import '../shared/mobile-menu.js';
import '../shared/mega-menu.js';

// Scroll-triggered fade-in animations ([data-fade-in])
import '../shared/landing/animations.js';

// FAQ accordion (expand/collapse)
import '../shared/faq.js';

document.addEventListener('DOMContentLoaded', () => {
  console.log('Comparison page loaded (Edge/Vite bundle)');
});
